module.exports = __webpack_public_path__ + "img/008.72928143.png";